import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-validate-button',
  imports: [],
  templateUrl: './validate-button.component.html',
})
export class ValidateButtonComponent {
  @Input()
  disabled = false

  @Input()
  text: string;

  @Output()
  onClick = new EventEmitter<void>()
}
